import { RouteConfig } from "vue-router";

import { HomeRoute } from "./Home";
import { UserRoute } from "./User";
import { AnnouncementRoute } from "./Announcement";
import { StoreRoute } from "./Store";
import { ReconciliationRoute } from "./Reconciliation";
import { LoginRoute } from "./Login";

export const ApplicationRouteRoute: Array<RouteConfig> = [
  ...HomeRoute,
  ...UserRoute,
  ...AnnouncementRoute,
  ...StoreRoute,
  ...ReconciliationRoute,
  ...LoginRoute,
];
